module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/timerangepicker/asset/arrow-right-black.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/timerangepicker/asset/arrow-right-black.png
// module id = 1278
// module chunks = 367